import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Modal from '../Modal'
;
import { dealAction } from '../../../store/deal-slice';
import GrClose from '@meronex/icons/gr/GrClose';

const RewardsPopupModal = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    
    const showRewardsModal = useSelector(
        (state) => state.deals.showRewardsModal
    );
const handleCloseRewardsModal = () => {
        dispatch(dealAction.setShowRewardsModal(false)); // Close the modal
        
    };
    return (
            <Modal
                className="w-[95%] md:w-[50%] lg:w-[45%] xl:w-[30%]"
                visible={showRewardsModal}
                onClick={handleCloseRewardsModal}
            >
                <div className="flex justify-end mr-4 mt-4">
                    <GrClose
                        onClick={handleCloseRewardsModal}
                        className="h-4 w-4 cursor-pointer self-end ml-auto"
                    />
                </div>
                <div className="text-center px-4 py-2">
                    <p className="text-sm lg:text-base font-medium">
                        We noticed you have an unused points balance and more products to claim.
                    </p>
                    <div className="mt-6 flex items-center gap-3 mb-4">
                        <button
                           onClick={() => {
                            handleCloseRewardsModal(); // Close modal before navigating
                            history.push('/rewardStore');
                        }}
                            className="flex w-[50%] p-[10px] px-[5px] items-center gap-2 border justify-center border-primary font-normal text-primary rounded-md transition text-sm"
                        >
                            <span>Add more products</span>
                        </button>
                        <button
                            onClick={() => {
                                handleCloseRewardsModal(); // Close modal before navigating
                                history.push('/checkout');
                            }}
                            className="flex rounded-md w-[50%] p-[10px] px-[5px] text-center bg-primary flex items-center justify-center text-white font-normal text-sm"
                        >
                            <span>Proceed Anyway</span>
                        </button>
                    </div>
                </div>
            </Modal>
    );
};

export default RewardsPopupModal;
